"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Tooltip = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _core = require("@material-ui/core");

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _theme = require("@zip/theme");

var _react = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function getBackgroundColour(variant, theme) {
  switch (variant) {
    case 'grey':
      return theme.colors.neutral[500];

    case 'primary':
      return theme.name === _theme.fearless.name ? theme.colors.primary.dark : theme.colors.primary.medium;

    default:
      return theme.colors.white;
  }
}

function getTextColour(variant, theme) {
  switch (variant) {
    case 'primary':
    case 'grey':
      return theme.colors.white;

    default:
      return theme.colors.neutral[600];
  }
}

var useStyles = (0, _core.makeStyles)({
  tooltip: {
    backgroundColor: function backgroundColor(props) {
      return getBackgroundColour(props.variant, props.theme);
    },
    color: function color(props) {
      return getTextColour(props.variant, props.theme);
    },
    padding: function padding(props) {
      return props.dense ? 8 : 16;
    },
    maxWidth: function maxWidth(props) {
      var _props$maxWidth;

      return (_props$maxWidth = props.maxWidth) !== null && _props$maxWidth !== void 0 ? _props$maxWidth : '160px';
    },
    border: function border(props) {
      return props.variant === 'white' ? "1px solid ".concat(props.theme.colors.neutral[200]) : 'none';
    }
  },
  arrow: {
    color: function color(props) {
      return getBackgroundColour(props.variant, props.theme);
    },
    '&::before': {
      border: function border(props) {
        return props.variant === 'white' ? "1px solid ".concat(props.theme.colors.neutral[200]) : 'none';
      }
    }
  }
});

var Tooltip = function Tooltip(_ref) {
  var content = _ref.content,
      _ref$dense = _ref.dense,
      dense = _ref$dense === void 0 ? false : _ref$dense,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '160px' : _ref$maxWidth,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'white' : _ref$variant,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom-right' : _ref$placement,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["content", "dense", "maxWidth", "variant", "placement", "children"]);

  var theme = (0, _react.useTheme)();
  var styles = useStyles({
    theme: theme,
    dense: dense,
    maxWidth: maxWidth,
    variant: variant
  });
  return (0, _jsxRuntime.jsx)(_Tooltip["default"], _objectSpread(_objectSpread({
    title: content,
    PopperProps: {
      popperOptions: {
        modifiers: {
          offset: {
            enabled: placement === 'bottom-right',
            offset: '80px, 0'
          }
        }
      }
    },
    classes: styles,
    placement: placement === 'bottom-right' ? 'bottom-end' : placement
  }, props), {}, {
    children: children
  }));
};

exports.Tooltip = Tooltip;
var _default = Tooltip;
exports["default"] = _default;